import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useEffect, useState } from 'react';
import CustomSnackbar from '../../../components/Snackbar/Snackbar';
import useToggleTheme from '../../../hooks/useToggleTheme';
import { useAppSelector } from '../../../redux/hooks';
import * as Styles from '../Dashboard.styles';
import ListBookmark from './ListBookmark';

const WrapperBookmark = ({
  code,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
}) => {
  const { followCompanies } = useAppSelector((state) => state.bookmark);
  const { isDarkMode } = useToggleTheme();
  const [open, setOpen] = useState(false);
  const [openHover, setOpenHover] = useState(false);
  const [checked, setChecked] = useState([]);

  const handleSetChecked = () => {
    if (investmentCategories && !!investmentCategories.length) {
      const followCompaniesByCode = followCompanies.filter(
        (x) => x.machungkhoan === code
      );
      const listChecked = [];
      investmentCategories.forEach((investmentCategory) => {
        if (followCompaniesByCode && !!followCompaniesByCode.length) {
          const isFollowed = followCompaniesByCode.find(
            (company) => company.category_id === investmentCategory.id
          );
          if (isFollowed) {
            listChecked.push(investmentCategory.id);
          }
        }
      });
      setChecked(listChecked);
    }
  };

  const handleTooltipClose = () => {
    setOpen(false);
    setOpenHover(false);
  };

  const handleTooltipOpen = () => {
    if (!authenticated) {
      window.location.href = '/login';
      return;
    }
    if (investmentCategories && investmentCategories.length == 1) {
      if (checked.length) {
        deleteInvestmentCategory(investmentCategories[0].id, code);
        setChecked([]);
      } else {
        saveInvestmentCategory(investmentCategories[0].id, code);
        setChecked([investmentCategories[0].id]);
      }
    } else {
      setOpenHover(false);
      setOpen(true);
    }
  };

  const handleTooltipOpenHover = () => {
    setOpenHover(true);
    if (handleSetIsOpeningBookmark) {
      handleSetIsOpeningBookmark(code);
    }
  };

  const handleTooltipCloseHover = () => {
    setOpenHover(false);
  };

  const customTitleComponent = () => {
    if (checked.length) {
      return (
        <span className="block text-black text-sm font-normal">
          Xóa <b>{code}</b> ra khỏi danh mục theo dõi.
        </span>
      );
    } else {
      return (
        <span className="block text-black text-sm font-normal">
          Thêm <b>{code}</b> vào danh mục theo dõi.
        </span>
      );
    }
  };

  const backgroundColor = isDarkMode ? '#1a1c23' : '#fff';

  useEffect(() => {
    handleSetChecked();
  }, [investmentCategories, followCompanies]);

  useEffect(() => {
    if (isOpeningBookmark != code) {
      setOpen(false);
      setOpenHover(false);
    }
  }, [isOpeningBookmark]);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (investmentCategoriesMessage?.showMessage) {
      setOpenSnackbar(true);
    }
  }, [investmentCategoriesMessage]);

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div className="relative">
        <CustomSnackbar
          open={openSnackbar}
          message={investmentCategoriesMessage?.message}
          isError={investmentCategoriesMessage?.isError}
          onClose={handleSnackbarClose}
        />
        <Styles.Tooltip
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <ListBookmark
              code={code}
              checked={checked}
              setChecked={setChecked}
              isLoading={isInvestmentCategoriesLoading}
              investmentCategories={investmentCategories}
              saveInvestmentCategory={saveInvestmentCategory}
              deleteInvestmentCategory={deleteInvestmentCategory}
              backgroundColor={backgroundColor}
            />
          }
        >
          <span className="absolute inset-0 opacity-0">.</span>
        </Styles.Tooltip>
        <Styles.Tooltip
          open={openHover && !open}
          title={customTitleComponent()}
          onClose={() => handleTooltipCloseHover()}
          onOpen={() => handleTooltipOpenHover()}
          className="helper"
        >
          <span onClick={handleTooltipOpen} className="relative z-10">
            {checked.length == 0 ? (
              <BookmarkIcon className="hover:text-primary-main cursor-pointer" />
            ) : (
              <BookmarkAddedIcon className="text-yellow-primary hover:text-primary-main cursor-pointer" />
            )}
          </span>
        </Styles.Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default WrapperBookmark;
